import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { forceCorrectLoginPageGuard } from '@guards/force-correct-login-page.guard';
import { redirectIfActiveGuard } from '@guards/redirect-if-active.guard';
import { LoginPageRolesByRoute } from '@shared/enums/login-page-type';
import { BrandedAccountSetupResetComponent } from './branded-account-setup-reset/branded-account-setup-reset.component';
import { BrandedLoginComponent } from './branded-login/branded-login.component';
import {
  RedesignedChooseLoginComponent
} from './choose-login/redesigned-choose-login/redesigned-choose-login.component';
import {
  BrandedForgotPasswordComponent
} from './forgot-password/branded-forgot-password/branded-forgot-password.component';
import { InvalidTokenComponent } from './invalid-token/invalid-token.component';
import { LoginComponent } from './login.component';
import { SkofLoginComponent } from './login.skof/login.skof.component';
import { LtiAdvantageRedirectComponent } from './lti-advantage-redirect/lti-advantage-redirect.component';
import { LtiAdvantageRequestComponent } from './lti-advantage-request/lti-advantage-request.component';
import { LtiTokenExchangeComponent } from './lti-token-exchange/lti-token-exchange.component';
import { OAuth2Component } from './oauth2/oauth2.component';

const routes: Routes = [
  {
    path: 'login',
    canActivate: [
      forceCorrectLoginPageGuard,
      redirectIfActiveGuard
    ],
    children: [
      { path: '', component: RedesignedChooseLoginComponent },
      { path: 'teacher', redirectTo: 'user' },
      // The formMode property will toggle the form between parent, teacher/admin, and student.
      { path: 'parent', component: BrandedLoginComponent, data: { formMode: LoginPageRolesByRoute.Parent } },
      { path: 'user', component: BrandedLoginComponent, data: { formMode: LoginPageRolesByRoute.User } },
      { path: 'student', component: BrandedLoginComponent, data: { formMode: LoginPageRolesByRoute.Student } },
    ],
  },
  { // forgot password needs to bypass forceCorrectLoginPageGuard
    path: 'login',
    canActivate: [redirectIfActiveGuard],
    component: LoginComponent,
    children: [{ path: 'forgot-password', component: BrandedForgotPasswordComponent }]
  },
  { path: 'login/skof', component: SkofLoginComponent, canActivate: [redirectIfActiveGuard] },
  { path: 'set-password', component: BrandedAccountSetupResetComponent },
  { path: 'lti-token-exchange', canActivate: [redirectIfActiveGuard], component: LtiTokenExchangeComponent },
  { path: 'account-setup', canActivate: [redirectIfActiveGuard], component: BrandedAccountSetupResetComponent },
  { path: 'invalid-token', canActivate: [redirectIfActiveGuard], component: InvalidTokenComponent },
  // The clever path is maintained for backwards-compatibility.
  { path: 'clever', component: OAuth2Component },
  { path: 'oauth2/:provider', component: OAuth2Component },
  { path: 'lti-advantage-request', component: LtiAdvantageRequestComponent },
  { path: 'lti-advantage-redirect', component: LtiAdvantageRedirectComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class LoginRoutingModule { }
